
import Vue from 'vue'
import { IResourceItem } from '@interfaces/ResourcesTypes'

export default Vue.extend({
  name: 'ResourcesItem',
  props: {
    type: {
      type: Array,
      default: () => [],
    },
    item: { type: Object as Vue.PropType<IResourceItem> },
  },
})
